// Device type is determined in the resize handle based on the screen width in pixels combined with and orientation

// Constant value stored in resize slice to indicate if the screen width is mobile, tablet or desktop
export enum DEVICE_TYPE {
	MOBILE = 'mobile',
	TABLET = 'tablet',
	DESKTOP = 'desktop' 
}

// Device orientation constants
export enum DEVICE_ORIENTATION {
	LANDSCAPE = 'landscape',
	PORTRAITE = 'portraite'
}

// export const APP_WRAPPER_ID: string = 'rootWrapper'